export const getFormattedDate = (expire_at: string) => {
  const date = expire_at.includes('/')
    ? expire_at.split('/')
    : expire_at.split('-').reverse();

  if (expire_at.includes('/')) {
    const temp = date[0];
    date[0] = date[1];
    date[1] = temp;
  }

  const dateString = date.join('/');
  return dateString;
};

export const getMillsTimestamp = (timestamp: number) => {
  let _timestamp: number = timestamp;

  if (_timestamp.toString().length >= 9 && _timestamp.toString().length <= 11) {
    _timestamp = _timestamp * 1000;
  }

  return _timestamp;
};
